<template>
  <BLayoutExpansionTableAsync
    :value="participants"
    v-bind="$attrs"
    :actions="actions"
    :loading="isLoading"
    :readonly="readonly"
    title="Условия распространения"
    type-autocomplete="participants"
    type-table="participants"
    name="participants"
    return-object
    @action:append="onAppendParticipant"
    @action:delete="onRemoveParticipant"
    @action:edit="onEditParticipant"
    @action:download="onDownloadList"
  />
</template>

<script>
import BLayoutExpansionTableAsync from '@/components/layouts/BLayoutExpansionTableAsync.vue'

import { publicationsMapper as StoreMapper } from '../store'
import { DELETE, EDIT, DOWNLOAD } from '@/helpers/enums/table-actions'
import { lkParticipantPermissions as Permissions } from '@/helpers/enums/permission-models'
import { createPublicationsParticipantModalModal } from '@/views/Publications/utils'


export const TABLE_ACTIONS = Object.freeze([
  DOWNLOAD,
  EDIT,
  DELETE,
])

export default {
  name: 'PublicationsParticipantsExpansionTable',
  components: { BLayoutExpansionTableAsync },
  props: {
    publication: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    isLoading: false,
  }),
  computed: {
    ...StoreMapper.mapState(['participants']),
    actions() {
      const actions = TABLE_ACTIONS
      const restrictedActions = []
      if (this.$access(Permissions.edit)) restrictedActions.push(EDIT)
      if (this.$access(Permissions.delete)) restrictedActions.push(DELETE)
      return actions.filter((x) => restrictedActions.includes(x))
    },
    readonly() {
      return !this.$access(Permissions.edit)
    },
  },
  created() {
    this.getParticipants(this.publication)
  },
  methods: {
    ...StoreMapper.mapActions(['getParticipants', 'addParticipant', 'removeParticipant', 'exportParticipantUsers']),
    async onAppendParticipant(participant) {
      this.isLoading = true
      try {
        await this.addParticipant({
          options: this.publication,
          participant,
        })
      } catch (e) {
        this.$notice.errors(e)
      }
      this.isLoading = false
    },
    async onRemoveParticipant(data, callback) {
      const unwatch = callback?.()

      this.isLoading = true
      try {
        await this.removeParticipant({
          options: this.publication,
          participant: data,
        })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        this.isLoading = false
        unwatch?.()
      }
    },
    async onEditParticipant(participant) {
      const propsData = { participant_id: participant.id }
      const modal = await createPublicationsParticipantModalModal(this, propsData)
      await modal.open()
    },
    onDownloadList({ id }, callback) {
      const unwatch = callback?.()

      try {
        this.exportParticipantUsers({ id })
      } catch (e) {
        this.$notice.errors(e)
      } finally {
        unwatch?.()
      }
    },
  },
}
</script>
